// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { HelloThere } from '../hello-there/hello-there.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { UnAuthorizedPageContent } from 'src/app/api/remote-api/.portal.generated/models';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/authorize-service.service';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [HelloThere, TranslateModule, CommonModule],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class UnauthorizedComponent implements OnInit {
  unauthorizePageData$: Observable<UnAuthorizedPageContent | null> =
    this.authService.unauthorizePageContent.lastSuccessfulData$;

  constructor(private readonly authService: AuthService) {}

  ngOnInit(): void {
    this.authService.unauthorizePageContent.request();
  }

  openLink(url: string | null): void {
    if (url) {
      window.open(url, '_blank');
    }
  }
}
